import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Plus, Minus } from 'lucide-react';
export function ObjectionsSection() {
  const faqs = [{
    q: 'No tengo tiempo.',
    a: 'Por eso es un sistema de escenas. Solo necesitas 12 minutos al día. Puedes hacerlo en el auto o antes de dormir.'
  }, {
    q: 'Me da pena hablar.',
    a: 'La pena baja cuando tienes un guion. Saber exactamente qué decir elimina la incertidumbre que causa la vergüenza.'
  }, {
    q: '¿Y si no soy principiante?',
    a: 'Este producto es ideal para nivel intermedio bajo. Se enfoca en naturalidad y velocidad de respuesta, no en aprender los colores o números.'
  }, {
    q: '¿Y si me equivoco?',
    a: "Aquí entrenas corrección rápida. Te enseñamos frases como 'let me clarify…' para salir de errores con elegancia."
  }];
  return <Section data-id="element-239">
      <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-12 text-center" data-id="element-240">
        Preguntas Frecuentes
      </h2>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-241">
        {faqs.map((faq, idx) => <FAQItem key={idx} question={faq.q} answer={faq.a} data-id="element-242" />)}
      </div>
    </Section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-slate-200 rounded-lg overflow-hidden" data-id="element-243">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-6 bg-white text-left hover:bg-slate-50 transition-colors" data-id="element-244">
        <span className="font-bold text-slate-900 text-lg" data-id="element-245">{question}</span>
        {isOpen ? <Minus className="w-5 h-5 text-slate-400" data-id="element-246" /> : <Plus className="w-5 h-5 text-slate-400" data-id="element-247" />}
      </button>
      <motion.div initial={false} animate={{
      height: isOpen ? 'auto' : 0
    }} className="overflow-hidden bg-slate-50" data-id="element-248">
        <div className="p-6 pt-0 text-slate-600 leading-relaxed border-t border-slate-100 pt-4" data-id="element-249">
          {answer}
        </div>
      </motion.div>
    </div>;
}